module.exports = __webpack_public_path__ + "img/blockchain-banner.a7d7638c.svg";